import { ref } from 'vue'

/**
 * 基础设置刷新信号。
 * 每次板载配置/软件配置切换完成后递增，各基础设置子组件 watch 此值并重新从设备读取数据。
 */
export const basicSettingsRefreshTick = ref(0)

export function triggerBasicSettingsRefresh() {
  basicSettingsRefreshTick.value++
}
